import { render, staticRenderFns } from "./AtividadeIndex.vue?vue&type=template&id=07aa5893&scoped=true&"
import script from "./AtividadeIndex.vue?vue&type=script&lang=js&"
export * from "./AtividadeIndex.vue?vue&type=script&lang=js&"
import style0 from "./AtividadeIndex.vue?vue&type=style&index=0&id=07aa5893&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aa5893",
  null
  
)

export default component.exports